(function(){
  var loaded=false;
  function loadAll(){
    if(loaded)return;
    loaded=true;
    setTimeout(function(){
      var mc=document.createElement('script');
      mc.id='mcjs';
      mc.src='https://chimpstatic.com/mcjs-connected/js/users/11f8f1268118c1c62671e2853/1b7b6b7094ee14968d3ecd10b.js';
      document.head.appendChild(mc);
    },8000);
  }
  ['mousedown','touchstart','scroll','keydown'].forEach(function(e){
    document.addEventListener(e,loadAll,{passive:true,once:true});
  });
  setTimeout(loadAll,6000);
})();